import { useLocation } from 'react-router-dom'

import { Columns } from '@domain-group/suit-theme'

import useBrand, { useBrandForm } from '@hooks/useBrand'

import ImageSettingsPermissionsModule from '../ImageSettingsPermissionsModule'
import PageLayout from '../../../../components/PageLayout'
import WatermarkImageModule from '../WatermarkImageModule'
import WatermarkSettings from '../WatermarkSettings'

interface PageContentProps {
  brandId: number,
}

const PageContent = (props: PageContentProps) => {
  const { brandId } = props
  // useLocation to refresh the window.location. If not used location won't reload if URL changes
  useLocation()

  const brandPayload = useBrand({ id: brandId })
  const { brand, callbacks: { updateBrand }, updating } = brandPayload

  const brandFormPayload = useBrandForm(brand, { validateOn: 'change' })

  return (
    <PageLayout activeTabBarItemKey="image-settings" entityPayload={brandPayload}>
      <Columns flexDirection={['column', 'column', 'row']}>
        <Columns.Main>
          <WatermarkSettings
            brandId={brandId}
            callbacks={{ updateBrand }}
            formPayload={brandFormPayload}
            updating={updating}
          />
        </Columns.Main>

        <Columns.Sidebar>
          <WatermarkImageModule brandId={brandId} />

          <ImageSettingsPermissionsModule
            brandId={brandId}
            formPayload={brandFormPayload}
          />
        </Columns.Sidebar>
      </Columns>
    </PageLayout>
  )
}

export default PageContent
